"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _BaseButton = _interopRequireDefault(require("../Buttons/BaseButton"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ButtonGroup = _styledComponents.default.div.withConfig({
  displayName: "ButtonGroup",
  componentId: "design-system__sc-3db3iw-0"
})(["display:flex;button{border-radius:0;border-left-width:0;display:block;:hover{border-color:", ";box-shadow:0 0 0 1px ", " inset;}}& button:first-child{border-left-width:1px;border-radius:4px 0 0 4px;}& button:last-child{border-radius:0 4px 4px 0;}"], _BaseTheme.default.colors.bluegray, _BaseTheme.default.colors.bluegray);

const Button = _styledComponents.default.button.withConfig({
  displayName: "ButtonGroup__Button",
  componentId: "design-system__sc-3db3iw-1"
})(["", " background-color:", ";svg{height:24px;width:24px;display:block;}"], _BaseButton.default, props => props.active ? '#ECECEC' : _BaseTheme.default.colors.white);

ButtonGroup.Button = Button;
var _default = ButtonGroup;
exports.default = _default;